/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {SeatAssignRequest} from '../models/SeatAssignRequest';
import type {SeatAssignResponse} from '../models/SeatAssignResponse';
import type {SeatAssignmentStatus} from '../models/SeatAssignmentStatus';
import type {UserSeatAssignmentPage} from '../models/UserSeatAssignmentPage';

export interface AssignSeatToUser$Request {
    userId: number;
    seatAssignRequest: SeatAssignRequest;
}

export interface AssignSeatToUser$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const assignSeatToUserRequest = createAction<PayloadData<void, AssignSeatToUser$Request>>('USER_SEAT_ASSIGNMENTS__ASSIGN_SEAT_TO_USER__REQUEST');
export const assignSeatToUserSuccess = createAction<PayloadData<SeatAssignResponse, AssignSeatToUser$Request>>('USER_SEAT_ASSIGNMENTS__ASSIGN_SEAT_TO_USER__SUCCESS');
export const assignSeatToUserFailure = createAction<PayloadData<Error, AssignSeatToUser$Request, true>>('USER_SEAT_ASSIGNMENTS__ASSIGN_SEAT_TO_USER__FAILURE');

export const assignSeatToUserActions = [
    assignSeatToUserRequest,
    assignSeatToUserSuccess,
    assignSeatToUserFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {SeatAssignRequest} meta.seatAssignRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const assignSeatToUser = (meta: AssignSeatToUser$Request, config?: AssignSeatToUser$Config) => {
    return {
        CALL_API: {
            types: assignSeatToUserActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/seat-assignments`,
            TRANSPORT_REQUEST_BODY: meta.seatAssignRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUserSeatAssignments$Request {
    userId: number;
    productSubscriptionId?: string;
    status?: SeatAssignmentStatus;
    page?: number;
    size?: number;
}

export interface GetUserSeatAssignments$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserSeatAssignmentsRequest = createAction<PayloadData<void, GetUserSeatAssignments$Request>>('USER_SEAT_ASSIGNMENTS__GET_USER_SEAT_ASSIGNMENTS__REQUEST');
export const getUserSeatAssignmentsSuccess = createAction<PayloadData<UserSeatAssignmentPage, GetUserSeatAssignments$Request>>('USER_SEAT_ASSIGNMENTS__GET_USER_SEAT_ASSIGNMENTS__SUCCESS');
export const getUserSeatAssignmentsFailure = createAction<PayloadData<Error, GetUserSeatAssignments$Request, true>>('USER_SEAT_ASSIGNMENTS__GET_USER_SEAT_ASSIGNMENTS__FAILURE');

export const getUserSeatAssignmentsActions = [
    getUserSeatAssignmentsRequest,
    getUserSeatAssignmentsSuccess,
    getUserSeatAssignmentsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {string} [meta.productSubscriptionId]
 * @param {SeatAssignmentStatus} [meta.status]
 * @param {number} [meta.page]
 * @param {number} [meta.size]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserSeatAssignments = (meta: GetUserSeatAssignments$Request, config?: GetUserSeatAssignments$Config) => {
    const TRANSPORT_GET_PARAMS = {
        productSubscriptionId: meta.productSubscriptionId,
        status: meta.status,
        page: meta.page,
        size: meta.size,
    };
    return {
        CALL_API: {
            types: getUserSeatAssignmentsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/seat-assignments`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveSeatFromUser$Request {
    userId: number;
    seatAssignRequest: SeatAssignRequest;
}

export interface RemoveSeatFromUser$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeSeatFromUserRequest = createAction<PayloadData<void, RemoveSeatFromUser$Request>>('USER_SEAT_ASSIGNMENTS__REMOVE_SEAT_FROM_USER__REQUEST');
export const removeSeatFromUserSuccess = createAction<PayloadData<SeatAssignResponse, RemoveSeatFromUser$Request>>('USER_SEAT_ASSIGNMENTS__REMOVE_SEAT_FROM_USER__SUCCESS');
export const removeSeatFromUserFailure = createAction<PayloadData<Error, RemoveSeatFromUser$Request, true>>('USER_SEAT_ASSIGNMENTS__REMOVE_SEAT_FROM_USER__FAILURE');

export const removeSeatFromUserActions = [
    removeSeatFromUserRequest,
    removeSeatFromUserSuccess,
    removeSeatFromUserFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {SeatAssignRequest} meta.seatAssignRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeSeatFromUser = (meta: RemoveSeatFromUser$Request, config?: RemoveSeatFromUser$Config) => {
    return {
        CALL_API: {
            types: removeSeatFromUserActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/users/${meta.userId}/seat-assignments`,
            TRANSPORT_REQUEST_BODY: meta.seatAssignRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

